import * as React from 'react';
import { useSelector } from 'react-redux';
import { useDeviceType } from '@cian/ui-kit';
import { BuildersPromotions } from '../../components/BuildersPromotions';
import { selectBiggestBuildersPromos } from '../../selectors/biggestBuildersPromos';

export const BuildersPromotionsContainer = (): React.JSX.Element | null => {
  const deviceType = useDeviceType();
  const biggestBuildersPromos = useSelector(selectBiggestBuildersPromos);

  if (!biggestBuildersPromos) {
    return null;
  }

  return <BuildersPromotions deviceType={deviceType} biggestBuildersPromos={biggestBuildersPromos} />;
};
